import { useWindowDimensions } from 'react-native';

import { theme } from '@squire/ui';

export const useScreenWidth = () => {
  const { width } = useWindowDimensions();

  return Math.min(width, theme.breakpoints.tablet);
};
